// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000ac000001","60","35","80","wood","normal");
goods[1] =new setGoods("0000ac000008","70","35","80","wood","normal");
goods[2] =new setGoods("0000ac000015","80","35","80","wood","normal");
goods[3] =new setGoods("0000ac000022","90","35","80","wood","normal");
goods[4] =new setGoods("0000ac000029","100","35","80","wood","normal");
goods[5] =new setGoods("0000ac000036","110","35","80","wood","normal");
goods[6] =new setGoods("0000ac000043","120","35","80","wood","normal");
goods[7] =new setGoods("0000ac000050","130","35","80","wood","normal");
goods[8] =new setGoods("0000ac000057","140","35","80","wood","normal");
goods[9] =new setGoods("0000ac000064","150","35","80","wood","normal");
goods[10] =new setGoods("0000ac000071","160","35","80","wood","normal");
goods[11] =new setGoods("0000ac000078","170","35","80","wood","normal");
goods[12] =new setGoods("0000ac000085","180","35","80","wood","normal");
goods[13] =new setGoods("0000ac000092","60","40","80","wood","normal");
goods[14] =new setGoods("0000ac000099","70","40","80","wood","normal");
goods[15] =new setGoods("0000ac000106","80","40","80","wood","normal");
goods[16] =new setGoods("0000ac000113","90","40","80","wood","normal");
goods[17] =new setGoods("0000ac000120","100","40","80","wood","normal");
goods[18] =new setGoods("0000ac000127","110","40","80","wood","normal");
goods[19] =new setGoods("0000ac000134","120","40","80","wood","normal");
goods[20] =new setGoods("0000ac000141","130","40","80","wood","normal");
goods[21] =new setGoods("0000ac000148","140","40","80","wood","normal");
goods[22] =new setGoods("0000ac000155","150","40","80","wood","normal");
goods[23] =new setGoods("0000ac000162","160","40","80","wood","normal");
goods[24] =new setGoods("0000ac000169","170","40","80","wood","normal");
goods[25] =new setGoods("0000ac000176","180","40","80","wood","normal");
goods[26] =new setGoods("0000ac000183","60","45","80","wood","normal");
goods[27] =new setGoods("0000ac000190","70","45","80","wood","normal");
goods[28] =new setGoods("0000ac000197","80","45","80","wood","normal");
goods[29] =new setGoods("0000ac000204","90","45","80","wood","normal");
goods[30] =new setGoods("0000ac000211","100","45","80","wood","normal");
goods[31] =new setGoods("0000ac000218","110","45","80","wood","normal");
goods[32] =new setGoods("0000ac000225","120","45","80","wood","normal");
goods[33] =new setGoods("0000ac000232","130","45","80","wood","normal");
goods[34] =new setGoods("0000ac000239","140","45","80","wood","normal");
goods[35] =new setGoods("0000ac000246","150","45","80","wood","normal");
goods[36] =new setGoods("0000ac000253","160","45","80","wood","normal");
goods[37] =new setGoods("0000ac000260","170","45","80","wood","normal");
goods[38] =new setGoods("0000ac000267","180","45","80","wood","normal");
goods[39] =new setGoods("0000ac000274","60","50","80","wood","normal");
goods[40] =new setGoods("0000ac000281","70","50","80","wood","normal");
goods[41] =new setGoods("0000ac000288","80","50","80","wood","normal");
goods[42] =new setGoods("0000ac000295","90","50","80","wood","normal");
goods[43] =new setGoods("0000ac000302","100","50","80","wood","normal");
goods[44] =new setGoods("0000ac000309","110","50","80","wood","normal");
goods[45] =new setGoods("0000ac000316","120","50","80","wood","normal");
goods[46] =new setGoods("0000ac000323","130","50","80","wood","normal");
goods[47] =new setGoods("0000ac000330","140","50","80","wood","normal");
goods[48] =new setGoods("0000ac000337","150","50","80","wood","normal");
goods[49] =new setGoods("0000ac000344","160","50","80","wood","normal");
goods[50] =new setGoods("0000ac000351","170","50","80","wood","normal");
goods[51] =new setGoods("0000ac000358","180","50","80","wood","normal");
goods[52] =new setGoods("0000ac000365","60","55","80","wood","normal");
goods[53] =new setGoods("0000ac000372","70","55","80","wood","normal");
goods[54] =new setGoods("0000ac000379","80","55","80","wood","normal");
goods[55] =new setGoods("0000ac000386","90","55","80","wood","normal");
goods[56] =new setGoods("0000ac000393","100","55","80","wood","normal");
goods[57] =new setGoods("0000ac000400","110","55","80","wood","normal");
goods[58] =new setGoods("0000ac000407","120","55","80","wood","normal");
goods[59] =new setGoods("0000ac000414","130","55","80","wood","normal");
goods[60] =new setGoods("0000ac000421","140","55","80","wood","normal");
goods[61] =new setGoods("0000ac000428","150","55","80","wood","normal");
goods[62] =new setGoods("0000ac000435","160","55","80","wood","normal");
goods[63] =new setGoods("0000ac000442","170","55","80","wood","normal");
goods[64] =new setGoods("0000ac000449","180","55","80","wood","normal");
goods[65] =new setGoods("0000ac000456","60","60","80","wood","normal");
goods[66] =new setGoods("0000ac000463","70","60","80","wood","normal");
goods[67] =new setGoods("0000ac000470","80","60","80","wood","normal");
goods[68] =new setGoods("0000ac000477","90","60","80","wood","normal");
goods[69] =new setGoods("0000ac000484","100","60","80","wood","normal");
goods[70] =new setGoods("0000ac000491","110","60","80","wood","normal");
goods[71] =new setGoods("0000ac000498","120","60","80","wood","normal");
goods[72] =new setGoods("0000ac000505","130","60","80","wood","normal");
goods[73] =new setGoods("0000ac000512","140","60","80","wood","normal");
goods[74] =new setGoods("0000ac000519","150","60","80","wood","normal");
goods[75] =new setGoods("0000ac000526","160","60","80","wood","normal");
goods[76] =new setGoods("0000ac000533","170","60","80","wood","normal");
goods[77] =new setGoods("0000ac000540","180","60","80","wood","normal");
goods[78] =new setGoods("0000ac000547","60","35","90","wood","normal");
goods[79] =new setGoods("0000ac000554","70","35","90","wood","normal");
goods[80] =new setGoods("0000ac000561","80","35","90","wood","normal");
goods[81] =new setGoods("0000ac000568","90","35","90","wood","normal");
goods[82] =new setGoods("0000ac000575","100","35","90","wood","normal");
goods[83] =new setGoods("0000ac000582","110","35","90","wood","normal");
goods[84] =new setGoods("0000ac000589","120","35","90","wood","normal");
goods[85] =new setGoods("0000ac000596","130","35","90","wood","normal");
goods[86] =new setGoods("0000ac000603","140","35","90","wood","normal");
goods[87] =new setGoods("0000ac000610","150","35","90","wood","normal");
goods[88] =new setGoods("0000ac000617","160","35","90","wood","normal");
goods[89] =new setGoods("0000ac000624","170","35","90","wood","normal");
goods[90] =new setGoods("0000ac000631","180","35","90","wood","normal");
goods[91] =new setGoods("0000ac000638","60","40","90","wood","normal");
goods[92] =new setGoods("0000ac000645","70","40","90","wood","normal");
goods[93] =new setGoods("0000ac000652","80","40","90","wood","normal");
goods[94] =new setGoods("0000ac000659","90","40","90","wood","normal");
goods[95] =new setGoods("0000ac000666","100","40","90","wood","normal");
goods[96] =new setGoods("0000ac000673","110","40","90","wood","normal");
goods[97] =new setGoods("0000ac000680","120","40","90","wood","normal");
goods[98] =new setGoods("0000ac000687","130","40","90","wood","normal");
goods[99] =new setGoods("0000ac000694","140","40","90","wood","normal");
goods[100] =new setGoods("0000ac000701","150","40","90","wood","normal");
goods[101] =new setGoods("0000ac000708","160","40","90","wood","normal");
goods[102] =new setGoods("0000ac000715","170","40","90","wood","normal");
goods[103] =new setGoods("0000ac000722","180","40","90","wood","normal");
goods[104] =new setGoods("0000ac000729","60","45","90","wood","normal");
goods[105] =new setGoods("0000ac000736","70","45","90","wood","normal");
goods[106] =new setGoods("0000ac000743","80","45","90","wood","normal");
goods[107] =new setGoods("0000ac000750","90","45","90","wood","normal");
goods[108] =new setGoods("0000ac000757","100","45","90","wood","normal");
goods[109] =new setGoods("0000ac000764","110","45","90","wood","normal");
goods[110] =new setGoods("0000ac000771","120","45","90","wood","normal");
goods[111] =new setGoods("0000ac000778","130","45","90","wood","normal");
goods[112] =new setGoods("0000ac000785","140","45","90","wood","normal");
goods[113] =new setGoods("0000ac000792","150","45","90","wood","normal");
goods[114] =new setGoods("0000ac000799","160","45","90","wood","normal");
goods[115] =new setGoods("0000ac000806","170","45","90","wood","normal");
goods[116] =new setGoods("0000ac000813","180","45","90","wood","normal");
goods[117] =new setGoods("0000ac000820","60","50","90","wood","normal");
goods[118] =new setGoods("0000ac000827","70","50","90","wood","normal");
goods[119] =new setGoods("0000ac000834","80","50","90","wood","normal");
goods[120] =new setGoods("0000ac000841","90","50","90","wood","normal");
goods[121] =new setGoods("0000ac000848","100","50","90","wood","normal");
goods[122] =new setGoods("0000ac000855","110","50","90","wood","normal");
goods[123] =new setGoods("0000ac000862","120","50","90","wood","normal");
goods[124] =new setGoods("0000ac000869","130","50","90","wood","normal");
goods[125] =new setGoods("0000ac000876","140","50","90","wood","normal");
goods[126] =new setGoods("0000ac000883","150","50","90","wood","normal");
goods[127] =new setGoods("0000ac000890","160","50","90","wood","normal");
goods[128] =new setGoods("0000ac000897","170","50","90","wood","normal");
goods[129] =new setGoods("0000ac000904","180","50","90","wood","normal");
goods[130] =new setGoods("0000ac000911","60","55","90","wood","normal");
goods[131] =new setGoods("0000ac000918","70","55","90","wood","normal");
goods[132] =new setGoods("0000ac000925","80","55","90","wood","normal");
goods[133] =new setGoods("0000ac000932","90","55","90","wood","normal");
goods[134] =new setGoods("0000ac000939","100","55","90","wood","normal");
goods[135] =new setGoods("0000ac000946","110","55","90","wood","normal");
goods[136] =new setGoods("0000ac000953","120","55","90","wood","normal");
goods[137] =new setGoods("0000ac000960","130","55","90","wood","normal");
goods[138] =new setGoods("0000ac000967","140","55","90","wood","normal");
goods[139] =new setGoods("0000ac000974","150","55","90","wood","normal");
goods[140] =new setGoods("0000ac000981","160","55","90","wood","normal");
goods[141] =new setGoods("0000ac000988","170","55","90","wood","normal");
goods[142] =new setGoods("0000ac000995","180","55","90","wood","normal");
goods[143] =new setGoods("0000ac001002","60","60","90","wood","normal");
goods[144] =new setGoods("0000ac001009","70","60","90","wood","normal");
goods[145] =new setGoods("0000ac001016","80","60","90","wood","normal");
goods[146] =new setGoods("0000ac001023","90","60","90","wood","normal");
goods[147] =new setGoods("0000ac001030","100","60","90","wood","normal");
goods[148] =new setGoods("0000ac001037","110","60","90","wood","normal");
goods[149] =new setGoods("0000ac001044","120","60","90","wood","normal");
goods[150] =new setGoods("0000ac001051","130","60","90","wood","normal");
goods[151] =new setGoods("0000ac001058","140","60","90","wood","normal");
goods[152] =new setGoods("0000ac001065","150","60","90","wood","normal");
goods[153] =new setGoods("0000ac001072","160","60","90","wood","normal");
goods[154] =new setGoods("0000ac001079","170","60","90","wood","normal");
goods[155] =new setGoods("0000ac001086","180","60","90","wood","normal");
goods[156] =new setGoods("0000ac001093","60","35","100","wood","normal");
goods[157] =new setGoods("0000ac001100","70","35","100","wood","normal");
goods[158] =new setGoods("0000ac001107","80","35","100","wood","normal");
goods[159] =new setGoods("0000ac001114","90","35","100","wood","normal");
goods[160] =new setGoods("0000ac001121","100","35","100","wood","normal");
goods[161] =new setGoods("0000ac001128","110","35","100","wood","normal");
goods[162] =new setGoods("0000ac001135","120","35","100","wood","normal");
goods[163] =new setGoods("0000ac001142","130","35","100","wood","normal");
goods[164] =new setGoods("0000ac001149","140","35","100","wood","normal");
goods[165] =new setGoods("0000ac001156","150","35","100","wood","normal");
goods[166] =new setGoods("0000ac001163","160","35","100","wood","normal");
goods[167] =new setGoods("0000ac001170","170","35","100","wood","normal");
goods[168] =new setGoods("0000ac001177","180","35","100","wood","normal");
goods[169] =new setGoods("0000ac001184","60","40","100","wood","normal");
goods[170] =new setGoods("0000ac001191","70","40","100","wood","normal");
goods[171] =new setGoods("0000ac001198","80","40","100","wood","normal");
goods[172] =new setGoods("0000ac001205","90","40","100","wood","normal");
goods[173] =new setGoods("0000ac001212","100","40","100","wood","normal");
goods[174] =new setGoods("0000ac001219","110","40","100","wood","normal");
goods[175] =new setGoods("0000ac001226","120","40","100","wood","normal");
goods[176] =new setGoods("0000ac001233","130","40","100","wood","normal");
goods[177] =new setGoods("0000ac001240","140","40","100","wood","normal");
goods[178] =new setGoods("0000ac001247","150","40","100","wood","normal");
goods[179] =new setGoods("0000ac001254","160","40","100","wood","normal");
goods[180] =new setGoods("0000ac001261","170","40","100","wood","normal");
goods[181] =new setGoods("0000ac001268","180","40","100","wood","normal");
goods[182] =new setGoods("0000ac001275","60","45","100","wood","normal");
goods[183] =new setGoods("0000ac001282","70","45","100","wood","normal");
goods[184] =new setGoods("0000ac001289","80","45","100","wood","normal");
goods[185] =new setGoods("0000ac001296","90","45","100","wood","normal");
goods[186] =new setGoods("0000ac001303","100","45","100","wood","normal");
goods[187] =new setGoods("0000ac001310","110","45","100","wood","normal");
goods[188] =new setGoods("0000ac001317","120","45","100","wood","normal");
goods[189] =new setGoods("0000ac001324","130","45","100","wood","normal");
goods[190] =new setGoods("0000ac001331","140","45","100","wood","normal");
goods[191] =new setGoods("0000ac001338","150","45","100","wood","normal");
goods[192] =new setGoods("0000ac001345","160","45","100","wood","normal");
goods[193] =new setGoods("0000ac001352","170","45","100","wood","normal");
goods[194] =new setGoods("0000ac001359","180","45","100","wood","normal");
goods[195] =new setGoods("0000ac001366","60","50","100","wood","normal");
goods[196] =new setGoods("0000ac001373","70","50","100","wood","normal");
goods[197] =new setGoods("0000ac001380","80","50","100","wood","normal");
goods[198] =new setGoods("0000ac001387","90","50","100","wood","normal");
goods[199] =new setGoods("0000ac001394","100","50","100","wood","normal");
goods[200] =new setGoods("0000ac001401","110","50","100","wood","normal");
goods[201] =new setGoods("0000ac001408","120","50","100","wood","normal");
goods[202] =new setGoods("0000ac001415","130","50","100","wood","normal");
goods[203] =new setGoods("0000ac001422","140","50","100","wood","normal");
goods[204] =new setGoods("0000ac001429","150","50","100","wood","normal");
goods[205] =new setGoods("0000ac001436","160","50","100","wood","normal");
goods[206] =new setGoods("0000ac001443","170","50","100","wood","normal");
goods[207] =new setGoods("0000ac001450","180","50","100","wood","normal");
goods[208] =new setGoods("0000ac001457","60","55","100","wood","normal");
goods[209] =new setGoods("0000ac001464","70","55","100","wood","normal");
goods[210] =new setGoods("0000ac001471","80","55","100","wood","normal");
goods[211] =new setGoods("0000ac001478","90","55","100","wood","normal");
goods[212] =new setGoods("0000ac001485","100","55","100","wood","normal");
goods[213] =new setGoods("0000ac001492","110","55","100","wood","normal");
goods[214] =new setGoods("0000ac001499","120","55","100","wood","normal");
goods[215] =new setGoods("0000ac001506","130","55","100","wood","normal");
goods[216] =new setGoods("0000ac001513","140","55","100","wood","normal");
goods[217] =new setGoods("0000ac001520","150","55","100","wood","normal");
goods[218] =new setGoods("0000ac001527","160","55","100","wood","normal");
goods[219] =new setGoods("0000ac001534","170","55","100","wood","normal");
goods[220] =new setGoods("0000ac001541","180","55","100","wood","normal");
goods[221] =new setGoods("0000ac001548","60","60","100","wood","normal");
goods[222] =new setGoods("0000ac001555","70","60","100","wood","normal");
goods[223] =new setGoods("0000ac001562","80","60","100","wood","normal");
goods[224] =new setGoods("0000ac001569","90","60","100","wood","normal");
goods[225] =new setGoods("0000ac001576","100","60","100","wood","normal");
goods[226] =new setGoods("0000ac001583","110","60","100","wood","normal");
goods[227] =new setGoods("0000ac001590","120","60","100","wood","normal");
goods[228] =new setGoods("0000ac001597","130","60","100","wood","normal");
goods[229] =new setGoods("0000ac001604","140","60","100","wood","normal");
goods[230] =new setGoods("0000ac001611","150","60","100","wood","normal");
goods[231] =new setGoods("0000ac001618","160","60","100","wood","normal");
goods[232] =new setGoods("0000ac001625","170","60","100","wood","normal");
goods[233] =new setGoods("0000ac001632","180","60","100","wood","normal");
goods[234] =new setGoods("0000ac001639","60","35","110","wood","normal");
goods[235] =new setGoods("0000ac001646","70","35","110","wood","normal");
goods[236] =new setGoods("0000ac001653","80","35","110","wood","normal");
goods[237] =new setGoods("0000ac001660","90","35","110","wood","normal");
goods[238] =new setGoods("0000ac001667","100","35","110","wood","normal");
goods[239] =new setGoods("0000ac001674","110","35","110","wood","normal");
goods[240] =new setGoods("0000ac001681","120","35","110","wood","normal");
goods[241] =new setGoods("0000ac001688","130","35","110","wood","normal");
goods[242] =new setGoods("0000ac001695","140","35","110","wood","normal");
goods[243] =new setGoods("0000ac001702","150","35","110","wood","normal");
goods[244] =new setGoods("0000ac001709","160","35","110","wood","normal");
goods[245] =new setGoods("0000ac001716","170","35","110","wood","normal");
goods[246] =new setGoods("0000ac001723","180","35","110","wood","normal");
goods[247] =new setGoods("0000ac001730","60","40","110","wood","normal");
goods[248] =new setGoods("0000ac001737","70","40","110","wood","normal");
goods[249] =new setGoods("0000ac001744","80","40","110","wood","normal");
goods[250] =new setGoods("0000ac001751","90","40","110","wood","normal");
goods[251] =new setGoods("0000ac001758","100","40","110","wood","normal");
goods[252] =new setGoods("0000ac001765","110","40","110","wood","normal");
goods[253] =new setGoods("0000ac001772","120","40","110","wood","normal");
goods[254] =new setGoods("0000ac001779","130","40","110","wood","normal");
goods[255] =new setGoods("0000ac001786","140","40","110","wood","normal");
goods[256] =new setGoods("0000ac001793","150","40","110","wood","normal");
goods[257] =new setGoods("0000ac001800","160","40","110","wood","normal");
goods[258] =new setGoods("0000ac001807","170","40","110","wood","normal");
goods[259] =new setGoods("0000ac001814","180","40","110","wood","normal");
goods[260] =new setGoods("0000ac001821","60","45","110","wood","normal");
goods[261] =new setGoods("0000ac001828","70","45","110","wood","normal");
goods[262] =new setGoods("0000ac001835","80","45","110","wood","normal");
goods[263] =new setGoods("0000ac001842","90","45","110","wood","normal");
goods[264] =new setGoods("0000ac001849","100","45","110","wood","normal");
goods[265] =new setGoods("0000ac001856","110","45","110","wood","normal");
goods[266] =new setGoods("0000ac001863","120","45","110","wood","normal");
goods[267] =new setGoods("0000ac001870","130","45","110","wood","normal");
goods[268] =new setGoods("0000ac001877","140","45","110","wood","normal");
goods[269] =new setGoods("0000ac001884","150","45","110","wood","normal");
goods[270] =new setGoods("0000ac001891","160","45","110","wood","normal");
goods[271] =new setGoods("0000ac001898","170","45","110","wood","normal");
goods[272] =new setGoods("0000ac001905","180","45","110","wood","normal");
goods[273] =new setGoods("0000ac001912","60","50","110","wood","normal");
goods[274] =new setGoods("0000ac001919","70","50","110","wood","normal");
goods[275] =new setGoods("0000ac001926","80","50","110","wood","normal");
goods[276] =new setGoods("0000ac001933","90","50","110","wood","normal");
goods[277] =new setGoods("0000ac001940","100","50","110","wood","normal");
goods[278] =new setGoods("0000ac001947","110","50","110","wood","normal");
goods[279] =new setGoods("0000ac001954","120","50","110","wood","normal");
goods[280] =new setGoods("0000ac001961","130","50","110","wood","normal");
goods[281] =new setGoods("0000ac001968","140","50","110","wood","normal");
goods[282] =new setGoods("0000ac001975","150","50","110","wood","normal");
goods[283] =new setGoods("0000ac001982","160","50","110","wood","normal");
goods[284] =new setGoods("0000ac001989","170","50","110","wood","normal");
goods[285] =new setGoods("0000ac001996","180","50","110","wood","normal");
goods[286] =new setGoods("0000ac002003","60","55","110","wood","normal");
goods[287] =new setGoods("0000ac002010","70","55","110","wood","normal");
goods[288] =new setGoods("0000ac002017","80","55","110","wood","normal");
goods[289] =new setGoods("0000ac002024","90","55","110","wood","normal");
goods[290] =new setGoods("0000ac002031","100","55","110","wood","normal");
goods[291] =new setGoods("0000ac002038","110","55","110","wood","normal");
goods[292] =new setGoods("0000ac002045","120","55","110","wood","normal");
goods[293] =new setGoods("0000ac002052","130","55","110","wood","normal");
goods[294] =new setGoods("0000ac002059","140","55","110","wood","normal");
goods[295] =new setGoods("0000ac002066","150","55","110","wood","normal");
goods[296] =new setGoods("0000ac002073","160","55","110","wood","normal");
goods[297] =new setGoods("0000ac002080","170","55","110","wood","normal");
goods[298] =new setGoods("0000ac002087","180","55","110","wood","normal");
goods[299] =new setGoods("0000ac002094","60","60","110","wood","normal");
goods[300] =new setGoods("0000ac002101","70","60","110","wood","normal");
goods[301] =new setGoods("0000ac002108","80","60","110","wood","normal");
goods[302] =new setGoods("0000ac002115","90","60","110","wood","normal");
goods[303] =new setGoods("0000ac002122","100","60","110","wood","normal");
goods[304] =new setGoods("0000ac002129","110","60","110","wood","normal");
goods[305] =new setGoods("0000ac002136","120","60","110","wood","normal");
goods[306] =new setGoods("0000ac002143","130","60","110","wood","normal");
goods[307] =new setGoods("0000ac002150","140","60","110","wood","normal");
goods[308] =new setGoods("0000ac002157","150","60","110","wood","normal");
goods[309] =new setGoods("0000ac002164","160","60","110","wood","normal");
goods[310] =new setGoods("0000ac002171","170","60","110","wood","normal");
goods[311] =new setGoods("0000ac002178","180","60","110","wood","normal");
goods[312] =new setGoods("0000ac002185","60","35","120","wood","normal");
goods[313] =new setGoods("0000ac002192","70","35","120","wood","normal");
goods[314] =new setGoods("0000ac002199","80","35","120","wood","normal");
goods[315] =new setGoods("0000ac002206","90","35","120","wood","normal");
goods[316] =new setGoods("0000ac002213","100","35","120","wood","normal");
goods[317] =new setGoods("0000ac002220","110","35","120","wood","normal");
goods[318] =new setGoods("0000ac002227","120","35","120","wood","normal");
goods[319] =new setGoods("0000ac002234","130","35","120","wood","normal");
goods[320] =new setGoods("0000ac002241","140","35","120","wood","normal");
goods[321] =new setGoods("0000ac002248","150","35","120","wood","normal");
goods[322] =new setGoods("0000ac002255","160","35","120","wood","normal");
goods[323] =new setGoods("0000ac002262","170","35","120","wood","normal");
goods[324] =new setGoods("0000ac002269","180","35","120","wood","normal");
goods[325] =new setGoods("0000ac002276","60","40","120","wood","normal");
goods[326] =new setGoods("0000ac002283","70","40","120","wood","normal");
goods[327] =new setGoods("0000ac002290","80","40","120","wood","normal");
goods[328] =new setGoods("0000ac002297","90","40","120","wood","normal");
goods[329] =new setGoods("0000ac002304","100","40","120","wood","normal");
goods[330] =new setGoods("0000ac002311","110","40","120","wood","normal");
goods[331] =new setGoods("0000ac002318","120","40","120","wood","normal");
goods[332] =new setGoods("0000ac002325","130","40","120","wood","normal");
goods[333] =new setGoods("0000ac002332","140","40","120","wood","normal");
goods[334] =new setGoods("0000ac002339","150","40","120","wood","normal");
goods[335] =new setGoods("0000ac002346","160","40","120","wood","normal");
goods[336] =new setGoods("0000ac002353","170","40","120","wood","normal");
goods[337] =new setGoods("0000ac002360","180","40","120","wood","normal");
goods[338] =new setGoods("0000ac002367","60","45","120","wood","normal");
goods[339] =new setGoods("0000ac002374","70","45","120","wood","normal");
goods[340] =new setGoods("0000ac002381","80","45","120","wood","normal");
goods[341] =new setGoods("0000ac002388","90","45","120","wood","normal");
goods[342] =new setGoods("0000ac002395","100","45","120","wood","normal");
goods[343] =new setGoods("0000ac002402","110","45","120","wood","normal");
goods[344] =new setGoods("0000ac002409","120","45","120","wood","normal");
goods[345] =new setGoods("0000ac002416","130","45","120","wood","normal");
goods[346] =new setGoods("0000ac002423","140","45","120","wood","normal");
goods[347] =new setGoods("0000ac002430","150","45","120","wood","normal");
goods[348] =new setGoods("0000ac002437","160","45","120","wood","normal");
goods[349] =new setGoods("0000ac002444","170","45","120","wood","normal");
goods[350] =new setGoods("0000ac002451","180","45","120","wood","normal");
goods[351] =new setGoods("0000ac002458","60","50","120","wood","normal");
goods[352] =new setGoods("0000ac002465","70","50","120","wood","normal");
goods[353] =new setGoods("0000ac002472","80","50","120","wood","normal");
goods[354] =new setGoods("0000ac002479","90","50","120","wood","normal");
goods[355] =new setGoods("0000ac002486","100","50","120","wood","normal");
goods[356] =new setGoods("0000ac002493","110","50","120","wood","normal");
goods[357] =new setGoods("0000ac002500","120","50","120","wood","normal");
goods[358] =new setGoods("0000ac002507","130","50","120","wood","normal");
goods[359] =new setGoods("0000ac002514","140","50","120","wood","normal");
goods[360] =new setGoods("0000ac002521","150","50","120","wood","normal");
goods[361] =new setGoods("0000ac002528","160","50","120","wood","normal");
goods[362] =new setGoods("0000ac002535","170","50","120","wood","normal");
goods[363] =new setGoods("0000ac002542","180","50","120","wood","normal");
goods[364] =new setGoods("0000ac002549","60","55","120","wood","normal");
goods[365] =new setGoods("0000ac002556","70","55","120","wood","normal");
goods[366] =new setGoods("0000ac002563","80","55","120","wood","normal");
goods[367] =new setGoods("0000ac002570","90","55","120","wood","normal");
goods[368] =new setGoods("0000ac002577","100","55","120","wood","normal");
goods[369] =new setGoods("0000ac002584","110","55","120","wood","normal");
goods[370] =new setGoods("0000ac002591","120","55","120","wood","normal");
goods[371] =new setGoods("0000ac002598","130","55","120","wood","normal");
goods[372] =new setGoods("0000ac002605","140","55","120","wood","normal");
goods[373] =new setGoods("0000ac002612","150","55","120","wood","normal");
goods[374] =new setGoods("0000ac002619","160","55","120","wood","normal");
goods[375] =new setGoods("0000ac002626","170","55","120","wood","normal");
goods[376] =new setGoods("0000ac002633","180","55","120","wood","normal");
goods[377] =new setGoods("0000ac002640","60","60","120","wood","normal");
goods[378] =new setGoods("0000ac002647","70","60","120","wood","normal");
goods[379] =new setGoods("0000ac002654","80","60","120","wood","normal");
goods[380] =new setGoods("0000ac002661","90","60","120","wood","normal");
goods[381] =new setGoods("0000ac002668","100","60","120","wood","normal");
goods[382] =new setGoods("0000ac002675","110","60","120","wood","normal");
goods[383] =new setGoods("0000ac002682","120","60","120","wood","normal");
goods[384] =new setGoods("0000ac002689","130","60","120","wood","normal");
goods[385] =new setGoods("0000ac002696","140","60","120","wood","normal");
goods[386] =new setGoods("0000ac002703","150","60","120","wood","normal");
goods[387] =new setGoods("0000ac002710","160","60","120","wood","normal");
goods[388] =new setGoods("0000ac002717","170","60","120","wood","normal");
goods[389] =new setGoods("0000ac002724","180","60","120","wood","normal");

